import React, { useContext } from "react";

import FilterIcon from "../../icons/filter-icon";
import SearchIcon from "../../icons/search-icon";

import lbl from "../../data/Labels.json";

import { YearContext } from "../../contexts/yearContext";

const TableSearch = ({ query, hasFilter, showFilter, filter }) => {
  const { entryYear } = useContext(YearContext);

  const handleSubmit = (e) => {
    e.preventDefault();

    const {
      keyword: { value },
    } = e.target;

    if (value) {
        query({keyword: value});
    }
  };

  const clearFilter = ({ target }) => {
    if (!target.value) {
        query({ page: 1});
    }
  };

  return (
    <React.Fragment>
      <form className="keyword" onSubmit={(e) => handleSubmit(e)}>
        <div className="search-input">
          <input
            onChange={(e) => clearFilter(e)}
            placeholder={lbl.Search}
            maxLength={32}
            name="keyword"
            type="search"
            required
          />
          <button>
            <SearchIcon />
          </button>
        </div>
        {hasFilter && (
          <button
            onClick={() => showFilter(!filter)}
            className="filter"
            type="button"
          >
            <FilterIcon />
          </button>
        )}
      </form>
    </React.Fragment>
  );
};

export default TableSearch;
